import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';
import './FreePlanQRPage.css';

interface FreePlanQRPageProps {
  onStartTrialComplete?: () => void;
  onBack?: () => void;
}

const FreePlanQRPage: React.FC<FreePlanQRPageProps> = ({ onStartTrialComplete, onBack }) => {
  // Generate universal SMS QR code - works on all devices (iPhone, Android, etc.)
  const qrCodeUrl = 'sms:+16288679755?body=hi';

  const handleStartTrial = async () => {
    // Redirect directly to Stripe payment link
    window.location.href = 'https://buy.stripe.com/eVq00ibFu0RB82Rd5E1Jm00';

    if (onStartTrialComplete) {
      onStartTrialComplete();
    }
  };

  return (
    <div className="free-plan-qr-page">
      <div className="free-plan-qr-card">
        {onBack && (
          <button className="free-plan-back-button" onClick={onBack}>
            <ArrowLeft size={20} />
          </button>
        )}
        <h1 className="free-plan-title">Text Remi</h1>
        <p className="free-plan-subtitle">
          Scan the QR code to start chatting with Remi.
        </p>

        <div className="free-plan-qr-container">
          <QRCodeSVG
            value={qrCodeUrl}
            size={256}
            level="H"
            includeMargin={true}
            className="free-plan-qr-image"
          />
        </div>

        <p className="free-plan-description">
          Free plan does not have platform access, but you can talk to Remi to set up reminders
          and take notes about people.
        </p>

        <button
          className="free-plan-trial-button"
          onClick={handleStartTrial}
        >
          Click to start a 14 day trial
        </button>
      </div>
    </div>
  );
};

export default FreePlanQRPage;


